import React, { useState, useEffect } from 'react';
import './App.css';

// Components
import Navbar from './components/Navbar';
import Footer from './components/Footer';

// Pages
import Home from './pages/Home';
import Features from './pages/Features';
import About from './pages/About';
import Contact from './pages/Contact';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';

const App = () => {
  const [currentPage, setCurrentPage] = useState('home');

  // 监听URL hash变化
  useEffect(() => {
    const handleHashChange = () => {
      const hash = window.location.hash.slice(1) || '/'; // 去掉 # 号
      const page = hash.substring(1) || 'home'; // 去掉开头的 /
      setCurrentPage(page);
      window.scrollTo(0, 0);
    };

    // 初始加载时检查hash
    handleHashChange();

    // 监听hash变化
    window.addEventListener('hashchange', handleHashChange);

    return () => {
      window.removeEventListener('hashchange', handleHashChange);
    };
  }, []);

  // 渲染当前页面
  const renderPage = () => {
    switch(currentPage) {
      case 'home':
        return <Home />;
      case 'features':
        return <Features />;
      case 'about':
        return <About />;
      case 'contact':
        return <Contact />;
      case 'privacy':
        return <Privacy />;
      case 'terms':
        return <Terms />;
      default:
        return <Home />;
    }
  };

  return (
    <div className="app">
      <Navbar currentPage={currentPage} />
      <main>{renderPage()}</main>
      <Footer />
    </div>
  );
};

export default App;
